const Join = () => {
  return (
    <>
      <section id="join" className="join-section">
        <div className="container">
          <div className="join-content">
            <div className="join-content-text">
              <h2>
                Join CRYPTODOM <br /> <span> The crytpo revolution</span>
              </h2>
              <p>Start investing today for your crypto future tomorrow</p>
              <a href="https://www.linkedin.com/in/fabio-miguel-754a04272/">
                Join Now
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default Join;
